import { Col, Image, Row, Typography } from "antd"
import React from "react"
import PageHeader from "../../components/Elements/PageHeader"
import { ShoppingCartOutlined } from "@ant-design/icons"
import StandartTable from "../../components/Elements/StandartTable"
import { useCollection } from "../../hooks/useCollection"
import moment from "moment"
import { OrderAndPrefix } from "../../components/Orders/Helpers/OrderAndPrefix"

const { Text } = Typography

export default function WinderDoneList() {
  const { data, loading } = useCollection(
    "orders",
    ["orderStatus", ">", 5],
    ["orderStatus", "<", 10]
  )

  // Filter the data on the client side
  const filteredData = data
    ? data.filter((order) => order.orderStatus > 5 && order.uid !== "E1XNaWvT6PccXRSKB3JNlNehI362")
    : []

  //default columns for table
  const defaultColumns = [
    {
      title: "Nr.",
      dataIndex: "orderNumber",
      align: "center",
      sorter: (a, b) => a.orderNumber - b.orderNumber,
      render: (value, record) => OrderAndPrefix(record),
    },
    {
      title: "Client",
      dataIndex: ["client", "client"],
      align: "center",
    },
    {
      title: "Order Name",
      dataIndex: ["selectedProduct", "product", "productName"],
      align: "center",
    },
    {
      title: "Manufacturer",
      dataIndex: ["manufacturer", "company"],
      align: "center",
    },
    {
      title: "Machine",
      dataIndex: ["selectedProduct", "machine"],
      align: "center",
    },
    {
      title: "Width",
      dataIndex: ["selectedProduct", "labelWidth"],
      align: "center",
    },
    {
      title: "Height",
      dataIndex: ["selectedProduct", "labelHeight"],
      align: "center",
    },
    {
      title: "Req. Amount",
      dataIndex: "labelCount",
      align: "center",
    },
    {
      title: "Amount Created",
      dataIndex: "amountCreated",
      align: "center",
    },
    {
      title: "Job Done",
      dataIndex: "doneByRewinder",
      align: "center",
      sorter: (a, b) => (a.doneByRewinder?.seconds || 0) - (b.doneByRewinder?.seconds || 0),
      render: (value) => (
        <>
          <Text>{value ? moment.unix(value.seconds).format("DD/MM/YYYY") : "N/A"}</Text>
        </>
      ),
    },
    {
      title: "Created",
      dataIndex: "created",
      align: "center",
      sorter: (a, b) => (a.created?.seconds || 0) - (b.created?.seconds || 0),
      render: (value) => (
        <>
          <Text>{value ? moment.unix(value.seconds).format("DD/MM/YYYY") : "N/A"}</Text>
        </>
      ),
    },

    {
      title: "Technical",
      dataIndex: "technicalPage",
      align: "center",
      render: (value) => <Image src={value} width={50} height={50} />,
    },
  ]

  return (
    <div style={{ padding: 15 }}>
      <Row gutter={[15, 15]}>
        <Col span={24}>
          <PageHeader text="Winder Done List" icon={<ShoppingCartOutlined />} />
        </Col>
        <Col span={24}>
          <StandartTable data={filteredData} loading={loading} columns={defaultColumns} />
        </Col>
      </Row>
    </div>
  )
}
